import React, { useState } from 'react'
import DownloadedContent from './DownloadedContent'
import Spinner from './Spinner'
import Step from '../components/Step'

function DowloaderForm() {
    const [show, setShow] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [progress, setProgress] = useState(0)
    const [downloadContentFormat, setdownloadContentFormat] = useState(null)
    const [format, setFormat] = useState(null)
    const [data, setData] = useState({
        status: "downloading",
        total_percentage: "",
        YoutubeAPI: {
            thumbUrl: "https://dummyimage.com/720x400",
            titolo: "",
            urlVideo: "",
            urlMp3: "",
            durata_video: ""
        }
    })
    const [inputText, setInputText] = useState({
        textLink: ""
    })
    const handleClick1 = () => {
        setSpinner(true)
        setShow(true)
        fetchGuid("video")
    }
    const handleClick2 = () => {
        setSpinner(true)
        setShow(true)
        fetchGuid("mp3")
    }
    const onChange = (e) => {
        setInputText({ ...inputText, [e.target.name]: e.target.value })
    }

    const fetchData = async (guid) => {

        const options = {
            method: 'GET',
            headers: {
                // 'X-RapidAPI-Key': '86abd3673cmsh59ac1d407b11fa0p17942ejsn6880d55e0a92',
                // 'X-RapidAPI-Key': 'e9e28bffbemsh37a042c84edc32dp15d318jsn02841d2ca8d5',
                // 'X-RapidAPI-Key': '046aa053b2msh6265c5c5e6e49a1p154f98jsn65ff54eedb88',
                'X-RapidAPI-Key': '5cd7979338msh2a6dbd7394bf680p13142ejsna83a3f30d758',
                'X-RapidAPI-Host': 't-one-youtube-converter.p.rapidapi.com'
            }
        };
        let linkURL = `https://t-one-youtube-converter.p.rapidapi.com/api/v1/statusProcess?guid=${guid}&responseFormat=json&lang=en`;
        const response = await fetch(linkURL, options)
        const data = await response.json();
        setData(data)
        setSpinner(false)
        if (data.status !== "complete") {
            setTimeout(() => {
                fetchData(guid)
            }, 1000);
        }
        setProgress(data.total_percentage)
    }
    const fetchGuid = async (format) => {

        const options = {
            method: 'GET',
            headers: {
                // 'X-RapidAPI-Key': '046aa053b2msh6265c5c5e6e49a1p154f98jsn65ff54eedb88',
                // 'X-RapidAPI-Key': 'e9e28bffbemsh37a042c84edc32dp15d318jsn02841d2ca8d5',
                // 'X-RapidAPI-Key': '86abd3673cmsh59ac1d407b11fa0p17942ejsn6880d55e0a92',
                'X-RapidAPI-Key': '5cd7979338msh2a6dbd7394bf680p13142ejsna83a3f30d758',
                'X-RapidAPI-Host': 't-one-youtube-converter.p.rapidapi.com'
            }
        };
        let encodeURL = encodeURIComponent(inputText.textLink)
        // let format = "mp3"
        let linkURL = `https://t-one-youtube-converter.p.rapidapi.com/api/v1/createProcess?url=${encodeURL}&format=${format}&responseFormat=json&lang=en`;
        const response = await fetch(linkURL, options)
        const data = await response.json();
        const guid = data.guid
     
        if (format === 'mp3') {
            setdownloadContentFormat(data.YoutubeAPI.urlMp3)
            setFormat('mp3')
        }
        else{
            setdownloadContentFormat(data.YoutubeAPI.urlVideo)
            setFormat('video')
        }

        setTimeout(() => {
            fetchData(guid)
        }, 1000);
    }

    return (
        <>
            <section className="text-gray-600 body-font" id="form">
                <div className="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
                    <div className="text-center lg:w-2/3 w-full">
                        <h1 className="title-font sm:text-4xl text-3xl mb-4 font-bold text-white">Youtube Video Downloader</h1>
                        <p className="mb-8 leading-relaxed font-semibold text-gray-300">Fast and free all in one Youtube video downloader</p>
                        <div className="flex justify-center">

                            <div className="relative sm:mr-4 lg:w-full xl:w-1/2 w-full">
                                <input type="text" id="hero-field" name="textLink" className="w-full bg-[#1d2942] bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:ring-indigo-200 focus:bg-transparent focus:border-indigo-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out " placeholder='Paste your video link here' onChange={onChange} />
                            </div>
                        </div>
                        <div className="flex justify-center mt-8 gap-x-3">
                            <a className="inline-flex text-[white] font-semibold bg-[#1A56DB] border-0 py-2 px-6 focus:outline-none hover:bg-white hover:text-[#111827]  rounded sm:text-lg" onClick={handleClick1} href="#downloadContent">Download Video</a>
                            <a className="inline-flex text-white font-semibold bg-[#1A56DB] border-0 py-2 px-6 focus:outline-none hover:bg-white hover:text-[#111827] rounded sm:text-lg" onClick={handleClick2} href="#downloadContent">Download Audio</a>
                        </div>
                    </div>

                </div>
            </section>
            <Step />
            <div id="downloadContent">
                {
                    spinner === true ?

                        <Spinner /> :

                        show && <DownloadedContent thumbnail={data.YoutubeAPI.thumbUrl ? data.YoutubeAPI.thumbUrl : ""} title={data.YoutubeAPI.titolo} format={format} download={downloadContentFormat} duration={data.YoutubeAPI.durata_video} progress={progress} />

                }
            </div>
        </>
    )
}

export default DowloaderForm